import type { TanstackSuspenseQueryOptions } from "@@/shared/hooks/use-tanstack-query";
import { useTanstackSingleSuspenseQuery } from "@@/shared/hooks/use-tanstack-query";
import type { ProductForm, ProductId } from "@towni/common";

const useProductFormSuspenseQuery = (
    productId: ProductId,
    options: TanstackSuspenseQueryOptions<ProductForm> = {},
) => {
    return useTanstackSingleSuspenseQuery<ProductForm>(
        `/products/${productId}/form`,
        ["product-forms", productId],
        options,
    );
};

export { useProductFormSuspenseQuery };
